<template>
  <div>
    <div class="home">
      <img src="../assets/logo(nuevo).png" class="logo-repro" alt="" />
      <!-- <img src="../assets/menores.svg" class="logo-footer" alt="" /> -->
      <img
        src="../assets/bg-int.jpg"
        v-show="!showVideo"
        @click="playVideo"
        class="video-img"
        alt=""
      />
      <video-player
        class="video-player-box"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        customEventName="customstatechangedeventname"
        v-show="showVideo"
        @play="onPlayerPlay($event)"
        @click.native="onPlayerPause($event)"
        @ended="onPlayerEnded($event)"
        @waiting="onPlayerWaiting($event)"
        @ready="playerReadied"
      >
      </video-player>

      <!-- <youtube class="embed-container" v-show="showVideo" :player-vars="{fs:0, modestbranding: 1, autohide:1, rel: 0, showinfo: 0, autoplay: 1, controls:0 }" :video-id="videoId" @ready="ready" @ended="ended" @playing="playing"></youtube> -->
      <btn-play v-if="!showVideo" @close="playVideo" />
    </div>
    <div class="home uvas" style="margin-top: -10px">
    

    


      <div class="container">
        <div>
          <img src="../assets/nuevo.svg" class="titulo-nuevo" alt="" />
        </div>
        <div class="envases">
          <img src="../assets/tinto(nuevo).png" class="envase" alt="" />
          <img src="../assets/blanco(nuevo).png" class="envase" alt="" />
          <!--<img src="../assets/rosado.png" class="envase"  alt="">-->
        </div>
       
      </div>
  
      <div class="container">
        <div class="wrapper">
          <div class="ventajas agregale">
            <img src="../assets/chielo.svg" alt="" />
            <h2>AGREGALE</h2>
            <p>HIELO u otra bebida</p>
          </div>
          <div class="ventajas">
            <img src="../assets/cguardalo.svg" alt="" />
            <h2>GUARDALO</h2>
            <p>acostado o como quieras</p>
          </div>
          <div class="ventajas cerralo">
            <img src="../assets/ccerralo.svg" alt="" />
            <h2>CERRALO</h2>
            <p>para mantener el sabor intacto</p>
          </div>
          <div class="ventajas servite">
            <img src="../assets/cservite.svg" alt="" />
            <h2>SERVITE</h2>
            <p>sin salpicar</p>
          </div>
        </div>
      </div>
      <div class="container">
        <img src="../assets/pasion3.svg" class="pasion" alt="" />
        <a
          href="https://www.facebook.com/TermidorPasionArgentina/"
          style="text-decoration: none"
          target="_blank"
        >
          <img
            src="../assets/encontranos.svg"
            style="
              max-width: 600px;
              display: block;
              text-align: center;
              margin: 30px auto;
            "
            alt=""
        /></a>
        <!-- <div id="fb-root"></div> -->
        <!-- <v-hack-script v-once>
(function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = 'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v3.2&appId=480481055806985&autoLogAppEvents=1';
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
    </v-hack-script> -->

        <div class="fbw">
          <!-- <div class="fb-page" data-href="https://www.facebook.com/TermidorPasionArgentina/" data-tabs="timeline" data-width="300" data-height="70" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="true"></div> -->
          <!-- <div class="fb-like" data-href="https://landing.promotermidor.com.ar" data-layout="button" data-action="like" data-size="large" data-show-faces="true" data-share="true"></div>     -->
          <a
            href="https://www.facebook.com/TermidorPasionArgentina/"
            style="text-decoration: none"
            class="fan-page"
            target="_blank"
          >
            <img src="../assets/fan2.svg" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import btnPlay from "@/components/boton.vue";
import btnHielo from "@/components/agregale.vue";
// require styles
import "video.js/dist/video-js.css";

import { videoPlayer } from "vue-video-player";
export default {
  components: {
    btnPlay,
    btnHielo,
    videoPlayer,
    "v-hack-script": {
      render: function (createElement) {
        return createElement("script", this.$slots.default);
      },
    },
  },
  data() {
    return {
      playerOptions: {
        // videojs options
        loop: false,
        muted: false,
        language: "es",
        nativeControlsForTouch: true,
        width: "80%",
        fluid: true,
        controls: false,
        preload: "auto",
        html5: {
          hls: {
            withCredentials: true,
          },
        },
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
      },
      videoId: "",
      showVideo: false,
      fbSdk: "sdd",
    };
  },
  created() {
    let hd = "https://termidor.com.ar/video/Comercial_Termidor_Intenso.mp4";
    let sd = "https://termidor.com.ar/video/Comercial_Termidor_Intenso.mp4";
    var w = window.innerWidth;
    console.log("ancho", w);
    if (w > 640) {
      this.playerOptions.sources[0].src = hd;
    } else {
      this.playerOptions.sources[0].src = sd;
    }

    console.log(this.playerOptions.sources[0].src);
  },
  mounted() {
    //  if (!document.getElementById('facebook-jssdk')) {
    //         (function(d, s, id) {
    //         var js, fjs = d.getElementsByTagName(s)[0];
    //         if (d.getElementById(id)) return;
    //         js = d.createElement(s); js.id = id;
    //         js.src = 'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v3.2&appId=2109117832700766&autoLogAppEvents=1';
    //         fjs.parentNode.insertBefore(js, fjs);
    //         }(document, 'script', 'facebook-jssdk'));
    // }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    playVideo() {
      // this.videoId =  'Ut0q-TWGzuE'
      setTimeout(() => {
        this.showVideo = true;
      }, 150);
      return this.$refs.videoPlayer.player.play();
    },

    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', this.$refs.videoPlayer)
      //  player.play()
    },
    onPlayerPause(player) {
      console.log("player pause!", this.$refs.videoPlayer.player.paused());
      if (this.$refs.videoPlayer.player.paused()) {
        this.$refs.videoPlayer.player.play();
        console.log("play");
      } else {
        this.$refs.videoPlayer.player.pause();
        console.log("pause");
      }
    },
    // ...player event

    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    onPlayerWaiting(player) {},
    // player is ready
    playerReadied(player) {
      console.log("the player is readied", player);

      // you can use it to do something...
      // player.[methods]
    },
    onPlayerEnded(player) {
      this.showVideo = false;
      console.log("fin");
      // player.stop()
    },
  },
};
</script>
<style>
.textointenso {
  width: 20%;
  padding: 10px;
  display: inline-block;
  transition: all 0.4s;
  cursor: pointer;
  margin: 0px auto;
  padding-bottom: 152px;
}
/* .envase{
    width:15%;
    padding: 10px;
    display:inline-block ;
    transition: all 0.4s;
    cursor: pointer;
   margin: 10px auto;
  
   
   
} */
.centrar-intenso {
  text-align: center;
}
.logo-footer {
  position: absolute;
  display: block;
  width: 55%;
  top: 90%;
  left: 0;
  right: 0;
  bottom: 00px;
  margin: auto;
}
.video-player-box {
  z-index: 1;
  width: 100%;
}
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.logo-repro {
  position: absolute;
  display: block;
  width: 25%;
  top: -250px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
</style>

<style scoped>
.fan-page {
  /* background: #4469B0;
    height: 28px;
    
    margin-left: 3px;
    border-radius:4px;
    font-family: 'Abel', sans-serif;
color:white;*/
  display: inline-block;
  
  margin-right: 70px;
  /* margin-top: 20px; */
}
.fan-page img {
  height: 28px;
  margin: 0 auto;
}
.fan-page span {
  padding: 4px;
  margin-top: -10px;
}
.fbw {
  text-align: center;
  width: 100%;
  margin: 0 auto;
  padding: 60px;
  
}
.like {
  font-family: "Abel", sans-serif;
  color: #8f0028;
  text-align: center;
  font-size: 30px;
  margin-top: -40px;
}
.pasion {
  width: 60%;
  display: block;
  text-align: center;
  margin: 90px auto;
}
.wrapper {
  display: table;
  width: 100%;
  /* width:100%;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(4, 25%);
  grid-template-rows: 25%;
  grid-auto-flow: column; */
}

.ventajas {
  display: table-cell;
  width: 25%;
  font-family: "Abel", sans-serif;
  transition: 0.6s;
}

.ventajas:hover {
  transform: scale(1.1);
}
.ventajas img {
  width: 50%;
  padding: 20px;
  display: block;
  text-align: center;
  margin: 0 auto;
}
.ventajas h2 {
  padding-bottom: 8px;
  width: 160px;
  text-align: center;
  color: #692f37;
  margin: 0 auto;
  border-bottom: 1px solid #8f0028;
}
.ventajas p {
  color: #8f0028;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
}
.titulo-nuevo {
  width: 60%;
  margin-top: 200px;
  padding: 80px;
  margin: 0 auto;
  display: block;
  margin-bottom: -60px;
}
.envases {
  width: 100%;
  /* background: #000; */
  display: table;
  margin: 10px auto;
  position: relative;
  text-align: center;
  margin-bottom: 15px;
}
.envases2 {
  width: 100%;
  /* background: #000; */
  display: table;
  margin: 10px auto;
  position: relative;
  text-align: center;
  margin-bottom: 15px;
}

.envaseintenso {
  background: url(~@/assets/bg-int.jpg) center center repeat-x;

  /*margin-bottom: 15px;*/
}
.envase:hover {
  transform: scale(1.1);
}
.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
/* .servite{
    margin-top: -30px;
} */
@media screen and (max-width: 650px) {
  .textointenso {
    width: 200px;
    padding: 10px;
    display: inline-block;
    transition: all 0.4s;
    cursor: pointer;
    margin: 0px auto;
    padding-bottom: 52px;
  }
  .fan-page {
    /* background: #4469B0;
    height: 28px;
    
    margin-left: 3px;
    border-radius:4px;
    font-family: 'Abel', sans-serif;
color:white;*/
    display: inline-block;
    margin-left: 0px;
    margin-top: 20px;
  }
  .pasion {
    width: 90%;
    display: block;
    text-align: center;
    margin: 60px auto;
  }

  .titulo-nuevo {
    width: 90%;
    margin: 40px 5%;
    padding: 0;
    float: left;
    text-align: center;
    display: block;
  }
  .envases {
    width: 100%;
    /* background: #000; */
    display: inline-table;
    margin: 0px auto;
    position: relative;
    text-align: center;
    margin-bottom: 10px;
  }
  .envases2 {
    width: 100%;
    /* background: #000; */
    display: inline-table;
    margin: 0px 15%;
    position: relative;
    text-align: center;
    margin-bottom: 10px;
  }
  .envase {
    width: 40%;
  }
  .ventajas {
    display: inline-table;
    width: 50%;
    font-family: "Abel", sans-serif;
    /* height: 200px; */
  }
  .ventajas img {
    width: 50%;
    padding: 20px;
    display: block;
    text-align: center;
    margin: 0 auto;
  }
  .ventajas h2 {
    padding-bottom: 8px;
    width: 120px;
    text-align: center;
    color: #692f37;
    margin: 0 auto;
    border-bottom: 1px solid #8f0028;
  }
  .ventajas p {
    color: #8f0028;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    height: 30px;
  }
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
  .textointenso {
    width: 300px;
    padding: 10px;
    display: inline-block;
    transition: all 0.4s;
    cursor: pointer;
    margin: 0px auto;
    padding-bottom: 152px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
  .textointenso {
    width: 300px;
    padding: 10px;
    display: inline-block;
    transition: all 0.4s;
    cursor: pointer;
    margin: 0px auto;
    padding-bottom: 152px;
  }
}
.img-nuevo {
  height: 400px;
  position: absolute;
}
.uvas {
  background: url("../assets/fondo-uvas.jpg") no-repeat top center;
  background-size: cover;
  height: 100%;
}
.home {
  /* background-image:url('../assets/previa.jpg'); */
  position: relative;
}
.video-img {
  width: 100%;
}
</style>